import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20amber%20and%20cream%20flowing%20shapes%2C%20minimal%20geometric%20patterns%2C%20elegant%20texture%2C%20subtle%20gold%20accents%2C%20professional%20yet%20inviting%20atmosphere%2C%20high%20resolution%20editorial%20style%20with%20dreamy%20atmosphere&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/80 to-primary-800/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-black text-background-50 mb-4">
          准备好提升你的效率了吗？
        </h2>
        <p className="text-sm md:text-base text-primary-100 mb-8 max-w-lg mx-auto leading-relaxed">
          加入 {120}+ 万用户的行列，免费获取海量优质资源，让学习与工作更高效、更快乐。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/study"
            className="px-8 py-3.5 bg-background-50 hover:bg-background-100 text-primary-700 font-bold text-sm rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            立即探索资源
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-transparent border-2 border-background-50/30 hover:border-background-50/60 text-background-50 font-bold text-sm rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}